<div id="{{ programEnum }}">
  <div class="inscription-page">
    <section class="container">
      <div class="d-flex row">
        <div class="col">
          <h3>{{ candidature?.name }}</h3>
        </div>
      </div>

      <div *ngIf="!candidature?.published">
        <hr />
        <h5 class="text-white">O período de inscrições não se encontra aberto!</h5>
        <h5 class="text-white">
          <a>Vê o estado da tua candidatura na tua área privada!</a>
        </h5>
        <hr />
        <div class="row">
          <div class="col-sm-24 frontend-modal-2">
            <button (click)="back()" class="btn btn-default"><span class="fa fa-angle-left"></span>&nbsp;Voltar</button>
          </div>
        </div>
      </div>
      <div *ngIf="applied && candidature?.published === true">
        <hr />
        <h5 class="text-white">Já estás inscrito para esta ação!</h5>
        <h5 class="text-white">
          <a
            >Vê o estado da tua candidatura na tua área privada! Lá também poderás inscrever-te noutras tarefas, caso as inscrições ainda
            estejam abertas!</a
          >
        </h5>
        <hr />
        <div class="row">
          <div class="col-sm-24 frontend-modal-2">
            <button (click)="back()" class="btn btn-default"><span class="fa fa-angle-left"></span>&nbsp;Voltar</button>
          </div>
        </div>
      </div>
      <div *ngIf="!applied && candidature?.published === true">
        <form name="inscricaoForm">
          <h5 class="text-white">Preenche o formulário para te inscreveres nesta ação de voluntariado jovem.</h5>
          <hr />
          <ng-wizard (stepChanged)="stepChanged($event)" [config]="config">
            <ng-wizard-step [canExit]="step2Valid.bind(this)" [title]="'Informação Específica'">
              <p class="text-white mt-2">Resposta ao questionário seguinte</p>
              <div *ngFor="let question of questions | orderBy: 'ordem'" class="form-row">
                <div class="form-group col-sm">
                  <label class="text-white mt-2">{{ question.question }}</label>
                  <select [(ngModel)]="answersList[question.id]" [ngModelOptions]="{ standalone: true }" class="form-control">
                    <option *ngFor="let choice of question.choices" [ngValue]="choice.id">{{ choice.choice }}</option>
                  </select>
                </div>
              </div>
            </ng-wizard-step>
            <ng-wizard-step [canExit]="step3Valid.bind(this)" [state]="step3State" [title]="'Localização Geográfica'">
              <p class="text-white mt-2">Seleciona o(s) local(is) onde pretendes realizar a ação</p>
              <p-table
                [(selection)]="selectedLocations"
                [autoLayout]="true"
                [columns]="colsLocation"
                [value]="candidature?.locations || []"
                dataKey="id"
              >
                <ng-template let-columns pTemplate="header">
                  <tr>
                    <th style="width: 30px; padding: 0.571em 0.857em">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th *ngFor="let col of columns">
                      {{ col.header }}
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template let-columns="columns" let-rowData pTemplate="body">
                  <tr>
                    <td style="width: 30px">
                      <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of columns">
                      {{ rowData[col.field] }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-wizard-step>
            <ng-wizard-step [title]="'Informação Geral'">
              <h5 class="text-white mt-2">A informação abaixo consta do teu perfil no Registo Único do IPDJ.</h5>
              <h5 class="text-white mt-2">Deves ter o teu perfil o mais completo possivel para te inscreveres nesta ação.</h5>
              <h5 class="text-white">
                Caso não tenhas o teu perfil atualizado, acede
                <a href="https://bdu.ipdj.gov.pt/personalData" target="_blank">aqui</a>
                para o completares.
              </h5>
              <hr />
              <div class="form-row">
                <div class="form-group col-sm">
                  <label class="form-control-label" jhiTranslate="app.young.civilStatus">civilStatus</label>
                  <p class="form-control-plaintext">{{ 'app.CivilStatus.' + person?.person?.civilStatus | translate }}</p>
                </div>
                <div class="form-group col-sm">
                  <label class="form-control-label" jhiTranslate="app.young.sex">sex</label>
                  <p class="form-control-plaintext">{{ 'app.Sex.' + person?.person?.sex | translate }}</p>
                </div>
                <div class="form-group col-sm">
                  <label class="form-control-label" jhiTranslate="app.young.dateOfBirth">dateOfBirth</label>
                  <p class="form-control-plaintext">{{ person?.person?.dateOfBirth }}</p>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-sm">
                  <label class="form-control-label" jhiTranslate="app.young.phones">phones</label>
                  <p class="form-control-plaintext">
                    <span *ngFor="let phone of person?.phones; let last = last">
                      {{ phone.phoneNumber }}
                      <span *ngIf="phone.extension">({{ phone.extension }})</span>
                      <fa-icon
                        *ngIf="phone.preferentialPhone"
                        [icon]="'check-circle'"
                        [appendTo]="'body'"
                        [pTooltip]="'Preferencial'"
                      ></fa-icon>
                      {{ last ? '' : ',' }}
                    </span>
                  </p>
                </div>
                <div class="form-group col-sm">
                  <label class="form-control-label" jhiTranslate="app.young.emails">phones</label>
                  <p class="form-control-plaintext">
                    <span *ngFor="let email of person?.emails; let last = last">
                      {{ email.email }}
                      <fa-icon
                        *ngIf="email.preferentialEmail"
                        [icon]="'check-circle'"
                        [appendTo]="'body'"
                        [pTooltip]="'Preferencial'"
                      ></fa-icon>
                      {{ last ? '' : ',' }}
                    </span>
                  </p>
                </div>
                <div class="form-group col-sm">
                  <label class="form-control-label">Documentos de Identificação</label>
                  <div class="table-responsive">
                    <table class="align-items-center table table-flush table-responsive">
                      <thead class="thead-light">
                        <tr>
                          <th>Documento</th>
                          <th>N.º Documento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let sector of getSectorIdentifications()">
                          <td>{{ 'app.CitizenIdentificationNumber.' + sector?.citizenIdentificationNumber | translate }}</td>
                          <td>{{ sector?.identificationNumber }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="align-items-center table table-flush table-responsive">
                  <thead class="thead-light">
                    <tr>
                      <th>Morada</th>
                      <th>Código Postal</th>
                      <th>Freguesia</th>
                      <th>Concelho</th>
                      <th>Preferencial</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let portugueseAddress of getPortugueseAddress()">
                      <td>
                        <span>
                          {{ portugueseAddress.postalCode?.arteryType }} {{ portugueseAddress.postalCode?.firstPreposition }}
                          {{ portugueseAddress.postalCode?.arteryTitle }} {{ portugueseAddress.postalCode?.secondPreposition }}
                          {{ portugueseAddress.postalCode?.arteryDesignation }} {{ portugueseAddress.postalCode?.arteryInformation }}
                          {{ portugueseAddress.door && portugueseAddress.door.trim().length > 0 ? ' nº ' : ''
                          }}{{ portugueseAddress.door }} {{ portugueseAddress.floor }} {{ portugueseAddress.side }}
                          {{ portugueseAddress.site }}</span
                        >
                      </td>
                      <td>
                        <span *ngIf="portugueseAddress.postalCode?.codeNumber"
                          >{{ portugueseAddress.postalCode?.codeNumber }} -{{ portugueseAddress.postalCode?.codeExtension }}</span
                        >
                      </td>
                      <td>
                        {{ portugueseAddress.locality }}
                      </td>
                      <td>{{ portugueseAddress.postalLocality }}</td>
                      <td>
                        <fa-icon *ngIf="portugueseAddress.preferential" [fixedWidth]="true" icon="check"></fa-icon>
                        <fa-icon *ngIf="!portugueseAddress.preferential" [fixedWidth]="true" icon="times"></fa-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-wizard-step>
          </ng-wizard>
          <div class="d-flex justify-content-between mt-4">
            <button (click)="back()" class="btn-pg btn-vermais"><fa-icon icon="angle-left"></fa-icon>&nbsp;Voltar</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</div>
